// React Imports
import React from "react";

// Package Imports
import { Card, Form, Row, Col } from "react-bootstrap";
import { observer } from "mobx-react-lite";
import { BottomsheetDropdown, DatepickerModal } from "components";
import { CalenderIcon, DOBIcon, GenderIcon, IncomeIcon, MonthlyIncomeIcon, lifeCoverIcon } from "constants/Images";
import { NUMBER_REGEX } from "constants/Constants";
import AccordionWithRaadioButton from "components/ui/accordion-with-radio-button/ AccordionWithRaadioButton";
import FamilyMemberTypeEnum from "modules/family-details-form/FamilymemberTypeEnum";
import UiButton from "components/ui/button/Button";
import { addNewMember } from "modules/family-details-form/non-individual-journey-form/utils";


const EmployeesCardInModal = (props) => {
    const { data, employeeName, updateValues, formController, isdone, memberId, checkDoneChange, indexOfEployee, employeesDetails } = props

    const memberfieldData = data.fields;
    let spouseGender = memberfieldData?.gender?.value;
    const showmonthlyIncome = memberfieldData?.monthly_income_value?.extra?.visible;
    //console.log("memberfieldData ", String(employeeName).startsWith("employee"))

    // const employeeNameFormat = (EmployeeName) => {
    //     let formatedName = EmployeeName.slice(0, 8).concat(" " , indexOfEployee + 1);
    //     return formatedName
    // }
    return (
        <AccordionWithRaadioButton
            memberID={memberId}
            isdone={isdone}
            title={data.label}
            familyMemberName={employeeName}
            memberData={data}
            formController={formController}
            updateValues={updateValues}
            checkDoneChange={checkDoneChange}
            disabled={false}
            familyFieldDetails={

                <Card className='border-0 add-family-member-card mx-md-2 mb-2 '>
                    <Card.Body className='p-2'>
                        <div className='d-flex align-items-center justify-content-end'>
                            <div className='d-flex min-width-150-px'>
                                <p className='font-size-12 mt-2 mt-md-1 mb-0 mr-1'>{memberfieldData.nationality.label}</p>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.nationality.extra.bottomSheetTitle}
                                    defaultLabel={memberfieldData.nationality.label}
                                    menuList={memberfieldData.nationality.extra.optionList}
                                    value={memberfieldData.nationality.value}
                                    onSelect={(value) => {
                                        updateValues(formController, employeeName, "nationality", value)
                                        // onDoneButtonChange(true)
                                    }}
                                    showErrorMsg={memberfieldData.nationality.error != null}
                                    disabled={false}
                                />
                            </div>
                        </div>
                        <hr className='mt-1 mb-2' style={{ border: "none", height: "1px", background: "#DF6336" }} />
                        <Row className='family-member-name-row pt-1'>
                            <Col className='title-col'>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.salutation.extra.bottomSheetTitle}
                                    defaultLabel=''
                                    menuList={memberfieldData.salutation.extra.optionList}
                                    onSelect={(value) => {
                                        updateValues(formController, employeeName, "salutation", value)
                                        // onDoneButtonChange(true)
                                    }}
                                    value={memberfieldData.salutation.value}
                                    showErrorMsg={memberfieldData.salutation.error !== null}
                                    errorMsg={memberfieldData.salutation.error}
                                />
                            </Col>

                            {/* firstName */}
                            <Col className='name-field-col'>
                                <Form.Group className='mb-0'>
                                    <Form.Control
                                        required
                                        placeholder={memberfieldData.first_name.placeholder}
                                        value={memberfieldData.first_name.value}
                                        onChange={(event) => {
                                            updateValues(formController, employeeName, "first_name", event.target.value)
                                            // onDoneButtonChange(true)
                                        }}
                                        className={`${memberfieldData.first_name.error ? "validation-border font-size-12 font-weight-light" : "font-size-12 font-weight-light"}`}
                                    />
                                    {memberfieldData.first_name.error && <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>{memberfieldData.first_name.error}</p>}
                                </Form.Group>
                            </Col>

                            {/* middleName */}
                            <Col className='name-field-col'>
                                <Form.Group className='mb-0'>
                                    <Form.Control
                                        placeholder={memberfieldData.middle_name.placeholder}
                                        value={memberfieldData.middle_name.value}
                                        onChange={(event) => {
                                            updateValues(formController, employeeName, "middle_name", event.target.value)
                                            // onDoneButtonChange(true)
                                        }}
                                        className={`${memberfieldData.middle_name.error ? "validation-border font-size-12 font-weight-light" : "font-size-12 font-weight-light"}`}
                                    />
                                    {memberfieldData.middle_name.error && <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>{memberfieldData.middle_name.error}</p>}
                                </Form.Group>
                            </Col>

                            {/* lastName */}
                            <Col className='name-field-col'>
                                <Form.Group className='mb-0'>
                                    <Form.Control
                                        placeholder={memberfieldData.last_name.placeholder}
                                        value={memberfieldData.last_name.value}
                                        onChange={(event) => {
                                            updateValues(formController, employeeName, "last_name", event.target.value)
                                            // onDoneButtonChange(true)
                                        }}
                                        className={`${memberfieldData.last_name.error ? "validation-border font-size-12 font-weight-light" : "font-size-12 font-weight-light"}`}
                                    />
                                    {memberfieldData.last_name.error && <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>{memberfieldData.last_name.error}</p>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='mt-2 family-member-name-row'>
                            <Col className='mt-1 mt-md-0 fm-modal-monthly-income-col order-last order-md-first pr-lg-3 '>
                                <div className='d-flex'>
                                    <img src={DOBIcon} alt='calender-icon' className='add-family-member-card-modal-top-img' />
                                    <p className='font-size-12 mb-2'>{memberfieldData.dob.label}</p>
                                </div>
                                <Form.Group className='mb-0'>
                                    <DatepickerModal
                                        dropdownStyle='font-size-12 '
                                        minDate={memberfieldData.dob.extra.minDate}
                                        maxDate={memberfieldData.dob.extra.maxDate}
                                        value={memberfieldData.dob.value}
                                        date={memberfieldData.dob.value}
                                        onChange={(value) => {
                                            updateValues(formController, employeeName, "dob", value)
                                            // onDoneButtonChange(true)
                                        }}
                                        showErrorMsg={memberfieldData.dob.error !== null}
                                        textStyle='font-size-12 font-weight-light'
                                        errorMsg={memberfieldData.dob.error}
                                        memberType={data.value.family_member_type}
                                    />
                                </Form.Group>
                            </Col>

                            <Col className='mt-1 mt-md-0 fm-modal-monthly-income-col order-first order-md-last pl-lg-3'>
                                <div className='d-flex'>
                                    <img src={GenderIcon} alt='calender-icon' className='add-family-member-card-modal-top-img' />
                                    <p className='font-size-12 mb-2'>{memberfieldData.gender.label}</p>
                                </div>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.gender.extra.bottomSheetTitle}
                                    defaultLabel='Select'
                                    disabled={memberfieldData.gender.disabled}
                                    menuList={memberfieldData.gender.extra.optionList}
                                    onSelect={(value) => {
                                        updateValues(formController, employeeName, "gender", value)
                                        // onDoneButtonChange(true)
                                    }}
                                    value={spouseGender}
                                    showErrorMsg={memberfieldData.gender.error !== null}
                                    errorMsg={memberfieldData.gender.error}
                                />
                            </Col>
                        </Row>
                        <hr className='my-2 d-none d-md-block' style={{ border: "none", height: "1px", background: "#DBE2EA" }} />

                        <Row className='mt-2 family-member-name-row'>
                            <Col className='mt-1 mt-md-0 fm-modal-monthly-income-col order-last order-md-first pr-lg-3'>
                                <div className='d-flex'>
                                    <img src={lifeCoverIcon} alt='calender-icon' className='add-family-member-card-modal-top-img' />
                                    <p className='font-size-12 mb-2'>{memberfieldData.current_life_cover.label}</p>
                                </div>
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={memberfieldData.current_life_cover.extra.bottomSheetTitle}
                                    menuList={memberfieldData.current_life_cover.extra.optionList}
                                    value={memberfieldData.current_life_cover.value}
                                    onSelect={(value) => {
                                        updateValues(formController, employeeName, "current_life_cover", value)
                                        // onDoneButtonChange(true)
                                    }}
                                    showErrorMsg={memberfieldData.current_life_cover.error !== null}
                                    disabled={memberfieldData.current_life_cover.disabled}
                                    errorMsg={memberfieldData.current_life_cover.error}
                                />
                            </Col>

                            <Col className={`mt-1 mt-md-0 fm-modal-monthly-income-col order-first order-md-last pl-lg-3 ${showmonthlyIncome ? "visible" : "invisible"}`}>
                                <div className='d-flex'>
                                    <img src={MonthlyIncomeIcon} alt='calender-icon' className='add-family-member-card-modal-top-img' />
                                    <p className='font-size-12 mb-2'>{memberfieldData.monthly_income_value.label}</p>
                                </div>
                                {memberfieldData.monthly_income_value.type === "text" ? (
                                    <Form.Group className='mb-0'>
                                        <Form.Control
                                            // type="number"
                                            placeholder={memberfieldData.monthly_income_value.placeholder}
                                            value={memberfieldData.monthly_income_value.value}
                                            onChange={(event) => {
                                                if (NUMBER_REGEX.test(event.target.value)) {
                                                    // onDoneButtonChange(true)
                                                    return updateValues(formController, employeeName, "monthly_income_value", event.target.value);
                                                }
                                                if (event.target.value.length <= 1) {
                                                    updateValues(formController, employeeName, "monthly_income_value", "");
                                                    // onDoneButtonChange(true)
                                                }
                                            }}
                                            disabled={memberfieldData.monthly_income_value.disabled}
                                            className={`${memberfieldData.monthly_income_value.error !== null ? "validation-border font-weight-light font-size-12 p-2" : "font-weight-light font-size-12 p-2"}`}
                                        />
                                        {memberfieldData.monthly_income_value.error && <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>{memberfieldData.monthly_income_value.error}</p>}
                                    </Form.Group>
                                ) : (
                                    <BottomsheetDropdown
                                        dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                                        menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                        menuItemStyle='d-flex justify-content-between align-items-center'
                                        selectedLabelKey='label'
                                        bottomsheetTitle={memberfieldData.monthly_income_dropdown_option.extra.bottomSheetTitle}
                                        defaultLabel='Select'
                                        menuList={memberfieldData.monthly_income_dropdown_option.extra.optionList}
                                        value={memberfieldData.monthly_income_dropdown_option.value}
                                        onSelect={(value) => {
                                            updateValues(formController, employeeName, "monthly_income_dropdown_option", value)
                                            // onDoneButtonChange(true)
                                        }}
                                        showErrorMsg={memberfieldData.monthly_income_dropdown_option.error != null}
                                        errorMsg={memberfieldData.monthly_income_dropdown_option.error}
                                        disabled={memberfieldData.monthly_income_dropdown_option.disabled}
                                    />
                                )}
                            </Col>
                        </Row>
                        {String(employeeName).startsWith("employee") && employeesDetails.length === indexOfEployee + 1 && <div className="py-2 d-flex justify-content-end">

                            <UiButton
                                variant=""
                                className="align-items-center p-0  text-secondary  font-size-16 font-weight-medium"
                                onClick={() => addNewMember(FamilyMemberTypeEnum.EMPLOYEE, formController)}
                            >
                                <span className="font-size-16 font-size-md-14">
                                    ADD ANOTHER EMPLOYEE
                                </span>
                            </UiButton>
                        </div>}
                        {String(employeeName).startsWith("family_member") && employeesDetails.length === indexOfEployee + 1 && <div className="py-2 d-flex justify-content-end">

                            <UiButton
                                variant=""
                                className="align-items-center p-0  text-secondary  font-size-16 font-weight-medium"
                                onClick={() => addNewMember(FamilyMemberTypeEnum.FAMILYMEMBER, formController)}
                            >
                                <span className="font-size-16 font-size-md-14">
                                    ADD ANOTHER FAMILY MEMBER
                                </span>
                            </UiButton>
                        </div>}
                        {/* {props.grandChildList.length === props.indexofGrandChild + 1 && <div className="py-2 d-flex justify-content-end">
                    <UiButton
                        variant=""
                        className="align-items-center p-0  text-secondary font-size-16 font-weight-medium"
                        onClick={() => addNewMember(FamilyMemberTypeEnum.GRAND_CHILD, formController)}
                    >
                        <span className="font-size-16 font-size-md-14">
                            ADD ANOTHER GRANDCHILD
                        </span>
                    </UiButton>
                </div>} */}

                    </Card.Body>
                </Card>
            }
        />
    )

}

export default observer(EmployeesCardInModal)
